import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

// Import global fetch wrapper to handle authentication automatically
import './utils/fetchWrapper';

import Login from "./components/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Home from "./components/Home";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Application from "./pages/Application";
import Creditmemo from "./pages/CreditMemo";  
import Scorecard from "./pages/Scorecard";
import Bsanalysis from "./pages/Bsanalysis";
import Creditmanagment from "./pages/Creditmanagment";
import ApplicationSummary from "./pages/Summary";
import Slide from "./pages/slide";
import UploadDocuments from "./components/UploadPage";
import Register from "./components/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import DateFilterTest from "./components/DateFilterTest";
import DashboardAnalyzer from "./pages/DashboardAnalyzer";

//  auth imports (same as yours)
import { initializeAuth } from "./services/authService";

function App() {

  useEffect(() => {
    console.log(" App mounted");

    //  THIS WAS MISSING — now auth logs WILL appear
    initializeAuth();

  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Protected Routes */}
        <Route path="/home" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />
        <Route path="/sidebar" element={
          <ProtectedRoute>
            <Sidebar />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/applicationdetail/:id" element={
          <ProtectedRoute>
            <Application />
          </ProtectedRoute>
        } />
        <Route path="/bsanalysis" element={
          <ProtectedRoute>
            <Bsanalysis />
          </ProtectedRoute>
        } />
        <Route path="/creditmanagment" element={
          <ProtectedRoute>
            <Creditmanagment />
          </ProtectedRoute>
        } />
        <Route path="/scorecard" element={
          <ProtectedRoute>
            <Scorecard />
          </ProtectedRoute>
        } />
        <Route path="/creditmemo" element={
          <ProtectedRoute>
            <Creditmemo />
          </ProtectedRoute>
        } />
        <Route path="/applicationsummary" element={
          <ProtectedRoute>
            <ApplicationSummary />
          </ProtectedRoute>
        } />
        <Route path="/slide" element={
          <ProtectedRoute>
            <Slide />
          </ProtectedRoute>
        } />
        <Route path="/upload-documents" element={
          <ProtectedRoute>
            <UploadDocuments />
          </ProtectedRoute>
        } />
        <Route path="/test-date-filter" element={
          <ProtectedRoute>
            <DateFilterTest />
          </ProtectedRoute>
        } />
        <Route path="/dashboard-analyzer" element={
          <ProtectedRoute>
            <DashboardAnalyzer />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
